import { useGlobalAction } from "@gadgetinc/react";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../../api";
import { OverflowFrame } from "../../../externalComponents";
import { PageHeading } from "../../../externalComponents/PageHeading";
import { SettingsSidebar } from "../../../externalComponents/SettingsSidebar";
import { Button } from "../../../externalComponents/tailwind/button";
import { Heading } from "../../../externalComponents/tailwind/heading";
import { Text } from "../../../externalComponents/tailwind/text";
import { CustomerContext } from "../../../providers";

export default function CompanyBillingPage() {
  const { customer } = useContext(CustomerContext);
  const [isLoading, setIsLoading] = useState(false);

  const [{ data }, getStripeInvoices] = useGlobalAction(api.getStripeInvoices);

  useEffect(() => {
    if (customer?.id) {
      getStripeInvoices({ customerId: customer.id });
    }
  }, [customer]);

  return (
    <>
      <SettingsSidebar>
        <PageHeading title="Billing" />
        <OverflowFrame>
          <div className="mt-5">
            <div className="mb-5">
              {!customer.isSubscribed && (
                <Button
                  loading={isLoading}
                  onClick={async () => {
                    setIsLoading(true);
                    const checkoutUrl = await api.createStripeCheckoutSession({
                      customerId: customer.id,
                    });
                    window.open(checkoutUrl, "_self");
                    setIsLoading(false);
                  }}
                >
                  Go to checkout
                </Button>
              )}
              {customer.isSubscribed && (
                <Heading>You are subscribed to Simio 🎉</Heading>
              )}
            </div>

            {(customer?.apiKey360Dialog || customer?.waAccessToken) && (
              <>
                <Link
                  to="https://business.facebook.com/wa/manage/phone-numbers/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button color="secondaryButton">
                    View consumption on Meta
                  </Button>
                </Link>
                <br />
                <br />
              </>
            )}
            {customer?.isStripeSubscribed && (
              <>
                {data && (
                  <>
                    <Text className="my-5 font-bold">Invoices</Text>
                    {data.map((item, index) => (
                      <div key={index}>
                        <Link
                          to={item.url}
                          target="_blank"
                          className="underline mb-1"
                        >
                          {item.date}
                        </Link>
                      </div>
                    ))}
                  </>
                )}
                <Link
                  to="https://billing.stripe.com/p/login/8wM28ggKr6XV4ve144"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button className="mt-5" color="secondaryButton">
                    Update Plan
                  </Button>
                </Link>
                <div className="mt-3">
                  <Text className="text-gray-500">
                    ⚠️ You must log in with the e-mail address you used for
                    payment.
                  </Text>
                </div>
              </>
            )}

            <Link
              to="https://help.getsimio.com/conditions-generales"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="mt-5" color="secondaryButton">
                Terms and conditions
              </Button>
            </Link>
          </div>
        </OverflowFrame>
      </SettingsSidebar>
    </>
  );
}
